import React from "react";

const Spec = () => {
  return (
    <div className="container mx-auto mt-16 mb-10 p-6">
      <div className="flex justify-center">
        <h1 className="text-3xl font-display font-semibold text-center">
          Orchid Nirvana 3.0 Specifications
        </h1>
      </div>
      <div className="mt-6 flex justify-center">
          <ul class="list list-disc">
            <li className="text-xl py-1">Rainwater Harvesting</li>
            <li className="text-xl py-1">Underground Sump</li>
            <li className="text-xl py-1">Overhead Tank</li>
            <li className="text-xl py-1">Landscaped Areas</li>
            <li className="text-xl py-1">Sewage Treatment Plant</li>
            <li className="text-xl py-1">Transform Yards</li>
            <li className="text-xl py-1">Service Staff Toilets</li>
            <li className="text-xl py-1">Underground Electrical Cabling</li>
            <li className="text-xl py-1">Underground Drain System</li>
          </ul>
        
      </div>
    </div>
  );
};

export default Spec;
